import { useCallback, useState } from 'react';

/**
 * Tracks date fields whose typed text is not a valid date. The picker rejects such text before it reaches
 * the form schema, so a form uses this to block saving and show INVALID_DATE_MESSAGE.
 * Connect each field's `onInvalidInputChange` to `onInvalidDateInput(fieldName)`.
 */
export const useInvalidDateInputs = () => {
  const [invalidFields, setInvalidFields] = useState<Record<string, boolean>>({});
  const onInvalidDateInput = useCallback(
    (fieldName: string) => (invalid: boolean) =>
      setInvalidFields((current) => (current[fieldName] === invalid ? current : { ...current, [fieldName]: invalid })),
    []
  );
  const resetInvalidDateInputs = useCallback(() => setInvalidFields({}), []);
  return {
    hasInvalidDateInput: Object.values(invalidFields).some(Boolean),
    onInvalidDateInput,
    resetInvalidDateInputs,
  };
};
